import {UserLevel} from '@netx/core-user-next/constants';

export const ATTRIBUTE_UPLOAD_MINIMUM_USER_LEVEL = UserLevel.PRODUCER;

export const ATTRIBUTE_UPLOAD_FILE_FORMATS = [
	'text/csv',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const DOCUMENTATION_LINK =
	'https://support.netx.net/hc/en-us/articles/4409720422039-Uploading-Attribute-Data';
